export const ActionTypes = {
    FETCH_LISTING_INITIAL_DATA_PROGRESS: "listing/fetch_listing_initial_data_progress",
    FETCH_LISTING_INITIAL_DATA_SUCCESS: "listing/fetch_listing_initial_data_success",
    FETCH_LISTING_INITIAL_DATA_FAILED: "listing/fetch_listing_initial_data_failed",
    FETCH_LISTING_DATA_PROGRESS: "listing/fetch_listing_data_progress",
    FETCH_LISTING_DATA_SUCCESS: "listing/fetch_listing_data_success",
    FETCH_LISTING_DATA_NOT_FOUND: "listing/fetch_listing_data_not_found",
    FETCH_LISTING_DATA_FAILED: "listing/fetch_listing_data_failed",
    SET_FILTERS: "listing/set_filters",
    SET_CATEGORY_ID: "listing/set_category_id",
    SET_SEARCH_TERM: "listing/set_search_term",
    APPLY_FILTERS: "listing/apply_filters",
    UPDATE_CURRENT_PAGE: "listing/update_current_page",
    UPDATE_SORT_BY: "listing/update_sort_by",
    RESET: "listing/reset",
};

export const applyFilters = (filterKey: string, values: string | number | string[]) => ({
    type: ActionTypes.APPLY_FILTERS,
    payload: { filterKey, values },
});

export const applySorting = (selectedValue: string) => ({
    type: ActionTypes.UPDATE_SORT_BY,
    payload: selectedValue,
});

export const setFilters = (filters: any) => ({ type: ActionTypes.SET_FILTERS, payload: filters });

export const updateCurrentPage = (pageNumber: number) => ({
    type: ActionTypes.UPDATE_CURRENT_PAGE,
    payload: pageNumber,
});

export const setCategoryId = (categoryId: string) => ({
    type: ActionTypes.SET_CATEGORY_ID,
    payload: categoryId,
});

export const setSearchTerm = (searchTerm: string) => ({
    type: ActionTypes.SET_SEARCH_TERM,
    payload: searchTerm,
});

export const reset = () => ({
    type: ActionTypes.RESET,
});
